import { render } from "./Dashboard.vue?vue&type=template&id=ac03c760&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=ac03c760&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/admin-ui-svc/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac03c760"]])

export default __exports__